//
//
//
//
//
//
//
//
//
//
//
//

import Loader from '@/components/autoscale/loader.vue';
import Sale from './new-design/index.vue';

export default {
  components: { Loader, Sale },
  meta: {
    show: ['br', 'mx'],
  },
  beforeRouteUpdate(to, from, next) {
    this.routeUpdate = Math.random();
    next();
  },
  layout: 'scaled',
  middleware: [
    'nomenclatureTypes',
    'setSale',
    'setSaleDirections',
    'saleGuard',
  ],
  data() {
    return {
      isLoading: true,
      routeUpdate: false,
    };
  },
  async created() {
    await this.userTagGuard();
  },
  methods: {
    async userTagGuard() {
      if (process.client) {
        try {
          const userTags = await this.$store.dispatch('user/getTags');

          if (this.$store.state.sale.sale.options?.userTags?.length) {
            const saleAllowedUserTags = new Set(
              this.$store.state.sale.sale.options?.userTags,
            );
            const currentUserTags = new Set(userTags.map((tag) => tag.title));
            const setOfTags = new Set([
              ...saleAllowedUserTags,
              ...currentUserTags,
            ]);
            if (
              saleAllowedUserTags.size + currentUserTags.size ===
              setOfTags.size
            ) {
              await this.$router.replace('/');
            }
          }
        } catch (e) {
          console.error(e);
        }

        this.isLoading = false;
      }
    },
  },
};
